<template>
  <div class="user_all">
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.environment') }}：</span>
      <el-select style="width: 250px" v-model="selectEnv" @change="changeEnv" :placeholder="this.$t('title.environment')">
        <el-option v-for="item in optionEnv" :key="item.code" :label="item.name" :value="item.code"></el-option>
      </el-select>
      <span style="width: 100px;display: inline-block;margin-left: 30px">{{ $t('title.system') }}：</span>
      <el-select style="width: 250px" v-model="selectApp" @change="changeApp" :placeholder="this.$t('title.system')">
        <el-option
          v-for="item in optionsApp"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.contract') }}：</span>
      <el-select
        style="width: 250px"
        v-model="selectConTem"
        :placeholder="this.$t('title.please_choose')"
      >
        <el-option
          v-for="item in optionConTem"
          :key="item.userContractId"
          :label="`${item.rpcServer} - ${item.chainId}链 - ${item.contractName}`"
          :value="item.userContractId"
        ></el-option>
      </el-select>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Reverse_input') }}：</span>
      <el-input type="primary" style="width: 30%;" :placeholder="this.$t('title.Please_enter_input')" v-model="inputValue"></el-input>
      <el-button type="primary" style="margin-left: 30px" @click="inverseSolution()">{{ $t('title.Sure') }}</el-button>
    </div>
    <div class="layout">
      <div class="setting">
        <ul>
          <li>
            <label>{{ $t('title.theme') }}</label>
            <select v-model="theme">
              <option value>{{ this.$t('title.default') }}</option>
              <option value="one-dark">one-dark</option>
              <option value="vs-code">vs-code</option>
            </select>
          </li>
          <li>
            <label>{{ $t('title.Collapse_all') }}</label>
            <select v-model="closed">
              <option :value="false">false</option>
              <option :value="true">true</option>
            </select>
          </li>

          <li>0.
            <label>deep</label>
            <select v-model="deep">
              <option v-for="item in 10" :value="item">{{item}}</option>
            </select>
          </li>
          <li>
            <label>font-size</label>
            <select v-model="fontSize">
              <option v-for="item in 10" :value="item+11">{{item+11}}</option>
            </select>
          </li>
          <li>
            <label for="line-height">line-height</label>
            <select v-model="lineHeight">
              <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
            </select>
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <json-view
        :data="json"
        :theme="theme"
        :deep="deep"
        :iconStyle="iconStyle"
        :fontSize="fontSize"
        :lineHeight="lineHeight"
        :closed="closed"
        :iconColor="iconColor"
      />
    </div>
  </div>
</template>

<script>
import {
	unpackInput,
	getenvList,
	getappList,
	getcontractList,
} from "../../../api/interface";
import jsonView from "../../json-view/index.vue";
import _ from 'lodash'
export default {
  name: "InverseSolutionOfInput",
  components: { jsonView },
  data() {
    return {
      isResponse: false,
      inputValue: "",
      json: {},
      theme: "",
      fontSize: 14,
      lineHeight: 24,
      deep: 3,
      iconStyle: "square",
      closed: false,
      color1: "",
      color2: "",
      selectEnv: 0,
      optionEnv: [],
      selectApp: 0,
			optionsApp: [],
			selectConTem: '',
			optionConTem: [],
    };
  },
  methods: {
    inverseSolution() {
      let data = {
        input: this.inputValue,
        userContractId: this.selectConTem
      };
      unpackInput(data).then(response => {
        console.log("111111");
        if (response.code == 200) {
          console.log("222");

          this.json = response.data;
        } else {
          this.json = {};
          this.$message.error(response.msg);
        }
      });
    },
    //环境切换时
    changeEnv() {
      console.log(this.selectEnv, 111111);
      this.getcontractLists();
    },
    //系统切换时
    changeApp() {
      console.log(this.selectApp, 111111);
      this.getcontractLists();
    },
    //初始化数据
    getData() {
      //获取环境
      getenvList().then(response => {
        this.optionEnv = response.data;
        this.selectEnv = this.optionEnv[0].code;
      });
      //获取系统
      getappList().then(response => {
        this.optionsApp = response.data;
        this.selectApp = this.optionsApp[0].code;
        
      });
      //获取合约
      this.getcontractLists();
    },
    //获取合约
    getcontractLists() {
      let data = {
        env: this.selectEnv,
        app: this.selectApp
      };
      getcontractList(data).then(response => {
        if (response.code == 200) {
          this.optionConTem = response.data;
          this.selectConTem = _.get(this.optionConTem[0], "userContractId", "");
          this.ConTemadds = _.get(this.optionConTem[0], "address", "");
        } else {
          this.optionConTem = [];
          this.$message.error(response.msg);
        }
      });
    }
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  created() {
    this.getData();
  }
};
</script>
<style scoped lang="less">
#app {
  .layout {
    /*width: 1200px;*/
    /*margin: 0 auto;*/

    h1 {
      font-size: 26px;
      font-weight: 400;
      margin: 12px 0;
    }

    a {
      display: block;
      background-color: #f8f8f9;
      border-radius: 4px;
      padding: 8px 16px;
      border: 1px solid #edeff0;
      border-radius: 4px;
      margin-bottom: 20px;
      text-decoration: none;
      color: #2d8cf0;
    }

    .setting {
      border: 1px solid #ccc;
      padding: 10px 20px;

      h3 {
        line-height: 1.6;
        font-size: 18px;
        color: #333;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;

      li {
        display: flex;
        align-items: center;
        padding: 10px 0;
        padding-right: 20px;

        label {
          font-size: 13px;
          padding-right: 10px;
          color: #333;
        }

        select {
          display: block;
          width: 80px;
          height: 28px;
          background: #fff;
        }
      }
    }
  }

  .content {
    border: 1px solid #ccc;
    border-top: none;
    max-height: 300px;
    overflow: auto;
    /*.content-wrap {*/
    /*   display: none !important;*/
    /*   background-color: rebeccapurple;*/
    /*}*/
  }
}
</style>
<style scoped>
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 30px;
}
</style>
